/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropTikTokVideoResponse } from './DropTikTokVideoResponse';
import {
    DropTikTokVideoResponseFromJSON,
    DropTikTokVideoResponseFromJSONTyped,
    DropTikTokVideoResponseToJSON,
    DropTikTokVideoResponseToJSONTyped,
} from './DropTikTokVideoResponse';

/**
 * 
 * @export
 * @interface DropTikTokVideosResponse
 */
export interface DropTikTokVideosResponse {
    /**
     * Bare TikTok handle to render in the official creator embed. Null when the Drop has no TikTok social or TikTok will not embed that profile (nonexistent, private, or malformed handle).
     * @type {string}
     * @memberof DropTikTokVideosResponse
     */
    handle: string | null;
    /**
     * Always empty for embed-rendered creators. Populated only for creators who connect their TikTok account, whose videos render in our own cards.
     * @type {Array<DropTikTokVideoResponse>}
     * @memberof DropTikTokVideosResponse
     */
    videos: Array<DropTikTokVideoResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropTikTokVideosResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropTikTokVideosResponse interface.
 */
export function instanceOfDropTikTokVideosResponse(value: object): value is DropTikTokVideosResponse {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('videos' in value) || value['videos'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropTikTokVideosResponseFromJSON(json: any): DropTikTokVideosResponse {
    return DropTikTokVideosResponseFromJSONTyped(json, false);
}

export function DropTikTokVideosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTikTokVideosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'videos': ((json['videos'] as Array<any>).map(DropTikTokVideoResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropTikTokVideosResponseToJSON(json: any): DropTikTokVideosResponse {
    return DropTikTokVideosResponseToJSONTyped(json, false);
}

export function DropTikTokVideosResponseToJSONTyped(value?: DropTikTokVideosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'videos': ((value['videos'] as Array<any>).map(DropTikTokVideoResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

